import "./Login.css";
import React, { useState, useContext } from "react";
import logo from "../../images/logo.svg";
import { useNavigate } from "react-router-dom";
import eyeHide from "../../images/eye-hide.svg";
import eyeShow from "../../images/eye-show.svg";
import { login, fetchUserDetails } from "../../api/api.js";
import { UserContext } from "../../contexts/CurrentUserContext.js";

function Login() {
  const { setUserData } = useContext(UserContext);
  const [loginValue, setLoginValue] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isPasswordNotEmpty, setIsPasswordNotEmpty] = useState(false);
  const navigate = useNavigate();

  const handleLoginChange = (e) => {
    setLoginValue(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setIsPasswordNotEmpty(!!e.target.value);
  };

  const toggleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await login(loginValue, password);
      const userData = await fetchUserDetails();
      console.log("Успешный вход");
      setUserData(userData); // Теперь setUserData определена
      navigate("/");
    } catch (error) {
      console.error("Ошибка при входе:", error);
      setError("Неверный логин или пароль.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="auth">
      <form className="auth__form" onSubmit={handleSubmit}>
        <h2 className="auth__title">Добро пожаловать!</h2>
        <p className="auth__subtitle">Введите логин и пароль</p>
        <ul className="auth__inputs">
          <li className="auth__inputs-container">
            <label className="auth__label">Логин</label>
            <input
              className="auth__input"
              placeholder="Введите логин"
              type="text"
              name="Login"
              value={loginValue}
              onChange={handleLoginChange}
            />
          </li>
          <span className="auth__input-error"></span>
          <li className="auth__inputs-container">
            <label className="auth__label">Пароль</label>
            <div className="auth__password-container">
              <input
                className="auth__input"
                placeholder="Введите пароль"
                type={showPassword ? "text" : "password"}
                name="Password"
                value={password}
                onChange={handlePasswordChange}
              />
              {isPasswordNotEmpty && (
                <button
                  type="button"
                  onClick={toggleShowPassword}
                  className="auth__toggle-password"
                >
                  <img
                    className="auth__button-img"
                    src={showPassword ? eyeShow : eyeHide}
                    alt={showPassword ? "Скрыть пароль" : "Показать пароль"}
                  />
                </button>
              )}
            </div>
          </li>
          <span className="auth__input-error"></span>
        </ul>
        <img className="auth__logo" src={logo} alt="Логотип" />
        <div className="auth__submit-container">
          <span className="auth__submit-error">{error}</span>
          <button
            className="auth__button-submit"
            type="submit"
            disabled={loading || !loginValue || !password}
          >
            {loading ? "Загрузка..." : "Войти"}
          </button>
        </div>
      </form>
    </main>
  );
}

export default Login;
